<template>
  <div>
    <back-route-hdr :back-mode="'static'"></back-route-hdr>
    <!-- 服务单相关 -->
    <div class="mar-top">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <div v-if="refreshTime && !serviceEdges.length">
          <empty-notice :image="'search'" :desc="'暂无服务信息'"></empty-notice>
        </div>

        <div v-else class="custom-steps">
          <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
            <van-cell-group v-for="(ele, idx) in serviceCells" :key="idx" :title="ele.month">
              <service-swipe-cell :service-list="ele.list"
                                  @reload-service="initServiceList"></service-swipe-cell>
            </van-cell-group>
          </van-list>
        </div>
      </van-pull-refresh>

    </div>
  </div>

</template>

<script>
  import {refreshDebounce} from "../../../../tools/utils";
  import {momentFormat, serviceConfig} from "../../../../config/common";
  import ServiceSwipeCell from "../../components/ServiceSwipeCell"
  import {service} from "../../../../server"
  import {getStorage, StorageKey} from "../../../../tools/storage";
  import routerMeta from "../../router/routerMeta";

  export default {
    components: {ServiceSwipeCell}, // 服务相关组件
    data() {
      return {
        userId: getStorage(StorageKey.userId),
        refreshing: false,
        refreshTime: "",
        serviceEdges: [],
        finished: false,
        loading: false,
        pageInfo: {
          pageSize: 10,
          pageNum: 1,
          pages: 1,
        },
      }
    },
    computed: {
      isSelfService() {
        return this.$route.name === routerMeta.selfService.name
      },
      serviceRooms() {
        const {serviceRooms} = this.$store.state.sysConfig;
        return serviceRooms || []
      },
      // 获取服务状态
      serviceStatusMap: function () {
        const obj = {};
        const sysConfig = this.$store.state.sysConfig || {};
        (sysConfig.serviceStatus || []).forEach(ele => obj[ele.value] = ele.label);
        return obj
      },
      // 处理数据渲染服务单列表
      serviceCells() {
        const obj = {};
        this.serviceEdges.forEach(edge => {
          const dmd = (edge.service.quickDemands || []).map(e => `${e.type} ${e.amount}${e.unit || '份'}`);
          edge.service.specificContent && dmd.push(edge.service.specificContent);
          const time = moment(edge.service.createdDate).format("MM月DD日 HH:mm");
          const ele = {
            ...edge.service,
            svId: edge.cursor,
            statusCN: this.serviceStatusMap[edge.service.status] || edge.service.status,
            title: dmd.join('；'),
            statusStyle: serviceConfig.statusStyle[edge.service.status] || serviceConfig.statusStyle.CANCELED,
            label: this.isSelfService ? time : `${edge.service.initiator.name} - ${time}`,
            roomNum: edge.service.meetingRoom && edge.service.meetingRoom.roomNum,
            sumPrice: (edge.service.quickDemands || []).reduce((sum, e) => {
              return sum + (e.amount && e.price ? e.amount * e.price : 0)
            }, 0)
          };
          const month = moment(ele.createdDate).format(momentFormat.dateFormatMonthCN);
          if (obj[month]) {
            obj[month].push(ele)
          } else {
            obj[month] = [ele]
          }
        });
        return Object.keys(obj).map(k => ({
          month: k,
          list: obj[k]
        }))
      },
    },
    methods: {
      onRefresh() {
        // console.log(this.refreshing);
        // 刷新防抖动
        if (this.refreshTime && refreshDebounce(this.refreshTime)) {
          this.refreshing = false;
          vtToast('刷新成功');
          return
        }
        this.initServiceList();
      },
      onLoad() {
        this.getServiceList(this.pageInfo.pageNum++)
      },
      initServiceList() {
        this.pageInfo.pageNum = 1;
        this.refreshTime = "";
        this.serviceEdges = [];
        this.finished = false;
        this.onLoad()
      },
      // 查询服务数据
      getServiceList(pageNum) {
        const filter = {
          pageNum,
          pageSize: this.pageInfo.pageSize,
        };
        if (this.isSelfService) {
          filter.createdBy = this.userId
        } else if (this.serviceRooms.length) {
          filter.meetingRoomIds = this.serviceRooms
        } else {
          this.loading = false;
          this.refreshing = false;
          this.finished = true;
          return
        }
        !this.refreshing && !this.loading && UILoader.load();
        service.queryList(this, {queryFilter: filter}).then(({searchService: data = {}}) => {
          UILoader.unload();
          // 列表懒加载
          this.loading = false;
          const {serviceEdges, pageInfo} = data;
          this.serviceEdges = this.serviceEdges.concat(serviceEdges || []);
          if (this.refreshing) {
            this.refreshing = false;
            vtToast('刷新成功');
          }
          this.refreshTime = new Date();
          this.pageInfo.pages = Math.ceil((pageInfo.total || 0) / this.pageInfo.pageSize);
          if (!pageInfo.total || pageNum >= this.pageInfo.pages) {
            this.finished = true
          }
        }).catch(err => {
          UILoader.unload();
          this.refreshing = false;
          this.loading = false;
          this.finished = true;
          vtToast(err.message)
        })
      },
    }
  }
</script>

<style scoped>
</style>
